export function importAllImagesFromFolder(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

export function mergeImageListWithThumbanilList(imageList, thumbnailList) {
  let imageListToReturn = [];

  imageList.map(function (file, index) {
    let thumbUrl = thumbnailList.find(i => i.title === `${file.title}_tn`).url;

    let newImage = {
      title: file.title,
      url: file.url,
      thumbnailUrl: thumbUrl
    }
    imageListToReturn.push(newImage);
  })

  return imageListToReturn;
}

export function pretifyImageList(imageList) {
  let imageListToReturn = [];

  for (let key in imageList) {
    let value = imageList[key];
    let newImage = {
      title: key.replace(/\.[^.]*$/, ''),
      url: value
    }
    imageListToReturn.push(newImage);
  }

  return imageListToReturn;
}

export function createItemList(itemList) {
  let rows = {}
  let counter = 1
  itemList.forEach((item, idx) => {
    rows[counter] = rows[counter] ? [...rows[counter]] : []
    if (idx % 3 === 0 && idx !== 0) {
      counter++
      rows[counter] = rows[counter] ? [...rows[counter]] : []
      rows[counter].push(item)
    } else {
      rows[counter].push(item)
    }
  })
  return rows
}


// WEBPACK FOOTER //
// ./src/components/helpers.js